var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWordmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 267,
    height: 72,
    viewBox: "0 0 267 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2127_255)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.5244 0.778564H0V11.0101H7.69737V71.2218H20.7297V13.3129L15.8491 11.0101H28.5244V0.778564Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.7982 0.778564V30.1583H45.2496V0.778564H33.061V71.2218H45.2496V43.4645L40.369 41.1617H51.7982V71.2218H63.9868V0.778564H51.7982Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.9133 0.778564H69.1982V71.2218H92.9133V60.9902H82.237V41.5543H91.7516V31.2246H82.237V13.3129L77.3564 11.0101H92.9133V0.778564Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.24 0.784912H141.525V71.2281H165.24V60.9966H154.564V41.5606H164.079V31.2309H154.564V13.3192L149.684 11.0165H165.24V0.784912Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.569 43.4449L191.266 48.9728L200.002 0.778564H187.891L185.977 19.3968H184.614L182.589 0.778564H169.719L174.223 25.5462L178.448 20.1164L175.826 34.5675L168.674 71.2218H181.453L183.952 51.0531H185.289L187.787 71.2218H200.963L195.569 43.4449Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.556 0.778564V58.6871C220.556 59.9301 220.556 62.2524 218.57 62.2524C216.473 62.2524 216.473 59.6619 216.473 58.6871V0.778564H203.435V56.3648C203.435 66.4458 208.808 71.9998 218.57 71.9998C228.331 71.9998 233.698 66.4458 233.698 56.3648V0.778564H220.556Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.484 34.4496L253.844 28.4376C251.313 26.0956 250.359 24.8984 250.359 21.549V13.3062C250.359 12.3315 250.359 9.74741 252.449 9.74741C253.903 9.74741 254.636 10.9446 254.636 13.3062V24.6956L266.903 22.3929V15.9295C266.903 5.50827 261.97 0 252.637 0C243.304 0 237.612 5.8092 237.612 15.9295V23.976C237.612 30.4198 239.8 33.6515 243.836 37.3607L250.95 43.654C253.15 45.5708 254.253 46.5324 254.253 49.8623V58.6873C254.253 61.0554 253.52 62.2526 252.066 62.2526C251.112 62.2526 249.97 61.6311 249.97 58.6873V47.01L237.612 49.3127V56.0705C237.612 66.4917 242.675 72 252.254 72C261.834 72 267 66.3413 267 56.0705V48.8941C267 41.6718 265.293 38.8326 260.484 34.4496Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.314 0.778564V71.2218H124.586L115.76 31.4601V41.9599L119.193 67.6368V71.2218H105.966V0.778564H117.694L126.52 40.5468V30.047L123.087 4.36353V0.778564H136.314Z",
    fill: "#F2F2F2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2127_255"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 267,
    height: 72,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWordmark);
export default __webpack_public_path__ + "static/media/wordmark.937519fd84f7a09b3bd25685f49322be.svg";
export { ForwardRef as ReactComponent };